import React from "react";
import styled from "styled-components";

interface Props {
  label: string;
  children: React.ReactNode;
}

export function Section({ label, children }: Props) {
  return (
    <Root>
      <Header>
        <HeaderText>{label}</HeaderText>
      </Header>
      <Children>{children}</Children>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  // justify-content: flex-end;
  padding: 5px 10px;
`;

const HeaderText = styled.div`
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 400;
  color: rgb(132, 156, 255);
`;

const Children = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 2px 0;
`;
